<template>
  <div id="poster" class="center">
    <div class="flex loginbox">
      <div v-if="!$bus.isPhone" style="position: relative;flex: 5">
        <img src="../assets/img/wenlv.png" style="width: 100%;height: 100%" />
        <div class="l-text">
          <img style="width:150px;height:150px" src="../assets/img/wllogo.png" alt="" />
          <div class="c-f mt10" style="font-size: 31px">平度文物安全监管平台</div>
        </div>
      </div>
      <div :class="` l-r center ${$bus.isPhone ? 'phone' : ''}`" style="flex: 4;position:relative">
        <!-- <img src="../assets/img/logo.png"> -->
        <h3 class="login_title">登录</h3>
        <el-form class="login-container" label-position="left" label-width="0px" :model="user" :rules="rules" ref="user">
          <el-form-item prop="username">
            <el-input prefix-icon="el-icon-user" type="text" v-model="user.username" auto-complete="off" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input prefix-icon="el-icon-lock" type="password" v-model="user.password" auto-complete="off" placeholder="请输入密码" show-password></el-input>
          </el-form-item>
          <el-form-item class="center f-right">
            <el-checkbox label="记住账号" v-model="saveNumber">记住账号</el-checkbox>
            <el-checkbox label="记住密码" v-model="savePass">记住密码</el-checkbox>
          </el-form-item>
          <div class="login-btn" :loading="loading" @click="submit">登 录</div>
        </el-form>
        <img src="../assets/img/pingduCode.png" style="width:13%;margin-top:2vw;height:12%" alt="" />
        <p>扫码下载文物巡检app</p>
        <!-- <div class="footer center  ">
          &copy;青岛同人建筑防火有限公司 &nbsp; <span class="ml10"> <a href="https://beian.miit.gov.cn">鲁ICP备17044344号-1</a></span>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { login, getWeihu } from '../api/common.js';

export default {
  components: {},
  data() {
    return {
      user: {
        username: '',
        password: '',
      },
      rules: {
        username: [{ required: true, message: '账号不能为空', trigger: 'blur' }],
        password: [{ required: true, message: '密码不能为空', trigger: 'blur' }],
      },
      savePass: true,
      saveNumber: true,
      loading: false,
    };
  },
  mounted() {},
  created() {
    
    if (this.$local.get('token')) {
      this.$router.replace('/');
    }
    if (this.$local.get('account')) {
      this.user = this.$local.get('account');
    }
    this.$local.remove('countList');
    this.$local.remove('bjstate');
    document.onkeydown = (e) => {
      //按下回车提交
      let key = window.event.keyCode;
      //事件中keycode=13为回车事件
      if (key == 13) {
        this.submit();
      }
    };
  },
  methods: {
    submit() {
      this.$refs['user'].validate((valid) => {
        if (valid) {
          if (this.savePass) {
            this.$local.save('account', this.user);
          } else {
            this.$local.remove('account');
          }
          this.login();
        } else {
          return false;
        }
      });
    },
    login() {
      this.loading = true;
      // this.$loading;

      //      var obj = this.$store.state.weihutime
      //   if(obj.endtime && obj.starttime && !this.$store.state.isDev ) {
      //           this.$alert(`尊敬的客户,我们将于 ${obj.starttime} 至 ${obj.endtime} 进行系统升级维护，维护期间系统暂时无法登入，给您造成不便，敬请谅解。`, '公告', {
      //       confirmButtonText: '确定',

      //     });
      //      }

      this.$store
        .dispatch('Login', this.user)
        .then((res) => {
          console.log(res);
          this.$router.push('/');
          setTimeout(() => {
            window.location.reload();
          }, 700);
        })
        .catch((er) => {
          this.loading = false;
          // this.getCode();
        });
      //    login(this.user).then(res=>{
      //         this.loading = false
      //         if(res.code==200){
      //             this.$message({
      //                 message: res.msg,
      //                 type: 'success'
      //             });
      //             if(this.savePass){
      //                 this.$local.save('account',this.user)
      //             }else{
      //                 this.$local.remove('account')
      //             }
      //             this.$store.commit('saveUser',res.data)
      //             //window.location.href = '/'
      //             this.$router.push('/')
      //         }
      //     }).catch(res=>{
      //         this.loading = false
      //         //this.$message.error('登录失败！')
      //     })
    },
  },
};
</script>
<style lang="scss">
.footer {
  font-size: 14px;
  bottom: 20px;
  position: absolute;
  a {
    text-decoration: underline;
    color: rgb(123, 123, 123);
  }
}
</style>
<style lang="scss" scoped>
#poster {
  background-position: center;
  height: 100%;
  width: 100%;
  background-size: cover;
  .l-text {
    position: absolute;
    text-align: center;
    width: 400px;
    height: 200px;
    left: 50%;
    top: 50%;
    margin-left: -200px;
    margin-top: -100px;
  }
  .phone {
    padding: 20px 40px !important;
    .login-container {
      width: 280px;
    }
    .login_title {
      font-size: 24px;
    }
  }
  .loginbox {
    // border-radius: 10px;
    // overflow: hidden;
    // box-shadow: 0px 4px 4px 3px rgba(0,0,0,.1);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    .l-r {
      background: #fff;
      flex-direction: column;
    }
    .el-input {
      line-height: 50px;
      height: 50px;
      input {
        height: 50px;
      }
    }
  }

  .login-container {
    width: 400px;
  }

  .login_title {
    margin: 25px auto 50px auto;
    text-align: center;
    color: #3d62de;
    font-size: 32px;
  }
  .login-btn {
    margin-top: 30px;
    width: 100%;
    height: 58px;
    line-height: 58px;
    font-size: 14px;
    text-align: center;
    color: #fff;
    background-image: linear-gradient(to right, #2b74ea, #56ccf2);
    cursor: pointer;
    border-radius: 5px;
    transition: all 0.3s;
    &:hover {
      opacity: 0.8;
    }
  }
}
#poster {
  background-position: center;
  height: 100%;
  width: 100%;
  background-size: cover;
  .l-text {
    position: absolute;
    text-align: center;
    width: 400px;
    height: 200px;
    left: 50%;
    top: 50%;
    margin-left: -200px;
    margin-top: -100px;
  }
  .phone {
    padding: 20px 40px !important;
    .login-container {
      width: 280px;
    }
    .login_title {
      font-size: 24px;
    }
  }
  .loginbox {
    // border-radius: 10px;
    // overflow: hidden;
    // box-shadow: 0px 4px 4px 3px rgba(0,0,0,.1);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    .l-r {
      background: #fff;
      flex-direction: column;
    }
    .el-input {
      line-height: 50px;
      height: 50px;
      input {
        height: 50px;
      }
    }
  }

  .login-container {
    width: 400px;
  }

  .login_title {
    margin: 25px auto 50px auto;
    text-align: center;
    color: #3d62de;
    font-size: 32px;
  }
  .login-btn {
    margin-top: 30px;
    width: 100%;
    height: 58px;
    line-height: 58px;
    font-size: 14px;
    text-align: center;
    color: #fff;
    background-image: linear-gradient(to right, #2b74ea, #56ccf2);
    cursor: pointer;
    border-radius: 5px;
    transition: all 0.3s;
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
